export const stepSets = {
  "sumario-denuncia": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "sumario-oficio": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "expediente-denuncia": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "expediente-oficio": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-flagrancia": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-propiedad-denuncia": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-propiedad-oficio": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-informatica-denuncia": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Afectación Patrimonial",
      name: "newActuacion-afectacion-patrimonial",
      path: "/newActuacion/afectacion-patrimonial",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-informatica-oficio": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    {
      label: "Afectación Patrimonial",
      name: "newActuacion-afectacion-patrimonial",
      path: "/newActuacion/afectacion-patrimonial",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-cavig": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-anivi": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-generica-denuncia": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-generica-oficio": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-establecer-paradero": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-emergencias-medicas": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-siniestro-vial": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-suicidio": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-incendio-vivienda": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-intoxicacion": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "ufi-otros": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "preliminares-incendio-vivienda": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "preliminares-establecer-procedencia": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "preliminares-fuga-menor": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "preliminares-siniestro-vial": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "preliminares-caida-casual": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "preliminares-incendio-automotor": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "preliminares-suicidio": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
  "preliminares-otros": [
    { label: "Afectados", name: "newActuacion-afectados", path: "/newActuacion/afectados" },
    { label: "Vinculados", name: "newActuacion-vinculados", path: "/newActuacion/vinculados" },
    {
      label: "Fecha, hora y ubicación",
      name: "newActuacion-fecha",
      path: "/newActuacion/fecha-hora-ubicacion",
    },
    { label: "Efectos", name: "newActuacion-efectos", path: "/newActuacion/efectos" },
    {
      label: "Personal Interviniente",
      name: "newActuacion-personal-interviniente",
      path: "/newActuacion/personal-interviniente",
    },
    { label: "Datos Legales", name: "newActuacion-datos", path: "/newActuacion/datos" },
    {
      label: "Visualización de acta",
      name: "newActuacion-visualizacion",
      path: "/newActuacion/visualizacion-acta",
    }
  ],
};

export const getStepDefs = (key) => {
  return stepSets[key];
};

export const flowLabels = {
  "sumario-denuncia": "Sumario Denuncia",
  "sumario-oficio": "Sumario Oficio",
  "expediente-denuncia": "Expediente Denuncia",
  "expediente-oficio": "Expediente Oficio",
  "ufi-flagrancia": "UFI Flagrancia",
  "ufi-propiedad-denuncia": "UFI Contra la Propiedad por Denuncia",
  "ufi-propiedad-oficio": "UFI Contra la Propiedad por Oficio",
  "ufi-informatica-denuncia": "UFI Informáticos y Estafas por Denuncia",
  "ufi-informatica-oficio": "UFI Informáticos y Estafas por Oficio",
  "ufi-cavig": "UFI Cavig",
  "ufi-anivi": "UFI Anivi",
  "ufi-generica-denuncia": "UFI Genérica por Denuncia",
  "ufi-generica-oficio": "UFI Genérica por Oficio",
  "ufi-establecer-paradero": "UFI Establecer Paradero",
  "ufi-emergencias-medicas": "UFI Emergencias Medicas",
  "ufi-siniestro-vial": "UFI Siniestro Vial",
  "ufi-suicidio": "UFI Ahorcamiento o Suicidio",
  "ufi-incendio-vivienda": "UFI Incendio en Vivienda",
  "ufi-intoxicacion": "UFI Intoxicacion",
  "ufi-otros": "UFI Otros",
  "preliminares-incendio-vivienda": "Preliminares Incendio en Vivienda",
  "preliminares-establecer-procedencia": "Preliminares Establecer Procedencia",
  "preliminares-fuga-menor": "Preliminares Fuga de Menor",
  "preliminares-siniestro-vial": "Preliminares Siniestro Vial",
  "preliminares-caida-casual": "Preliminares Caida Casual",
  "preliminares-incendio-automotor": "Preliminares Incendio Automotor",
  "preliminares-suicidio": "Preliminares Suicidio",
  "preliminares-otros": "Preliminares Otros",
};

export const getFlowLabel = (key) => {
  return flowLabels[key] || key || "";
};
